export default "__VITE_ASSET__bbf5c052__"